import { Form } from 'react-router';
import { AuthenticityTokenInput } from 'remix-utils/csrf/react';

import { Avatar } from '~/components/ui/avatar.tsx';
import { Button } from '~/components/ui/button.tsx';
import { Popover, PopoverContent, PopoverTrigger } from '~/components/ui/popover.tsx';
import { THUMBNAIL_SIZE } from '~/domain/shared/models/thumbnail-size';

import ThumbnailWithFallback from '../photos/thumbnail-with-fallback';

import { UserAvatarProfileLink } from './user-avatar-profile-link';

interface Props {
  email: string;
  displayName: string;
  avatarUrl?: string | null;
}

export function UserAvatarMenu({ avatarUrl, email, displayName }: Props) {
  return (
    <Popover>
      <PopoverTrigger>
        <Avatar className="size-8 overflow-hidden rounded-md">
          <ThumbnailWithFallback
            size={THUMBNAIL_SIZE.SQUARE_EXTRA_SMALL}
            url={avatarUrl}
            variant={'person'}
          />
        </Avatar>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto border-0 bg-background">
        <div className="flex flex-col gap-2">
          <UserAvatarProfileLink avatarUrl={avatarUrl} email={email} displayName={displayName} />
          <Form action="/logout" method="post">
            <AuthenticityTokenInput />
            <Button
              className="ml-14 mt-2 text-foreground hover:bg-transparent hover:text-foreground"
              variant="ghost"
              type="submit"
            >
              Log Out
            </Button>
          </Form>
        </div>
      </PopoverContent>
    </Popover>
  );
}
